<template>
  <el-date-picker
    v-model="newValue"
    :type="pickType"
    align="right"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions"
    @change="onChange"
    value-format="timestamp"
    :clearable="clearable"
  />
</template>

<script>
const shortcuts = {
  date: [
    { text: "最近一天", minutes: 24 * 60 },
    { text: "最近一周", minutes: 7 * 24 * 60 },
    { text: "最近一月", minutes: 30 * 24 * 60 },
    { text: "最近三月", minutes: 90 * 24 * 60 },
  ],
  full: [
    { text: "最近15分钟", minutes: 15 },
    { text: "最近30分钟", minutes: 30 },
    { text: "最近一小时", minutes: 60 },
    { text: "最近一天", minutes: 24 * 60 },
    { text: "最近一周", minutes: 7 * 24 * 60 },
    { text: "最近一月", minutes: 30 * 24 * 60 },
  ],
};

export default {
  name: "Date",
  props: {
    value: {
      required: true,
      default() {
        return [];
      },
    },
    format: {
      type: String,
      required: false,
      default: "full", // date, time, full
    },
    shortcuts: {
      type: Array,
      required: false,
      default() {
        return undefined;
      },
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal !== this.newValue) {
          this.newValue = newVal;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    const curShortcuts =
      this.shortcuts || shortcuts[this.format] || shortcuts.date;
    return {
      newValue: [],
      pickerOptions: {
        shortcuts: curShortcuts.map(({ text, minutes }) => ({
          text,
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 60 * 1000 * minutes);
            picker.$emit("pick", [start, end]);
          },
        })),
      },
    };
  },
  computed: {
    pickType() {
      return this.format === "full" ? "datetimerange" : "daterange";
    },
  },
  methods: {
    onChange(daterange) {
      this.$emit("input", daterange);
      this.$emit("change", daterange);
    },
  },
};
</script>
